export const Dashboardcard=()=>{
return(
    <>

    <div className="container ">
    <div className="row ">
  {/* Card 1: Total Users */}
  <div className="col-md-6 col-lg-3">
    <div className="card text-white bg-primary h-100">
      <div className="card-body">
        <h5 className="card-title">Total Users</h5>
        <h2 className="card-text" id="totalUsers">
          1,250
        </h2>
        <span className="badge bg-light text-primary">Active Users</span>
      </div>
    </div>
  </div>
  {/* Card 2: Total Orders */}
  <div className="col-md-6 col-lg-3">
    <div className="card text-white bg-success h-100">
      <div className="card-body">
        <h5 className="card-title">Total Orders</h5>
        <h2 className="card-text" id="totalOrders">
          3,420
        </h2>
        <span className="badge bg-light text-success">Completed</span>
      </div>
    </div>
  </div>
  {/* Card 3: Total Revenue */}
  <div className="col-md-6 col-lg-3">
    <div className="card text-white bg-warning h-100">
      <div className="card-body">
        <h5 className="card-title">Total Revenue</h5>
        <h2 className="card-text" id="totalRevenue">
          $85,000
        </h2>
        <span className="badge bg-light text-warning">This Month</span>
      </div>
    </div>
  </div>
  {/* Card 4: Total Products */}
  <div className="col-md-6 col-lg-3">
    <div className="card text-white bg-danger h-100">
      <div className="card-body">
        <h5 className="card-title">Total Products</h5>
        <h2 className="card-text" id="totalProducts">
          560
        </h2>
        <span className="badge bg-light text-danger">In Stock</span>
      </div>
    </div>
  </div>
</div>
</div>

    </>
)
}